import Cron from 'react-js-cron'
import 'react-js-cron/dist/styles.css'

import './Scheduler.css';

const Scheduler = (props) => {

  return (
    <Cron
        value={props.scheduleValue}
        setValue={props.setScheduleValue}
        className='cron-comp'
        humanizeLabels={true}
        humanizeValue
        allowedPeriods={['year', 'month', 'week']}
    />
  )
}

export default Scheduler